/* eslint-disable eqeqeq */
import { useEffect, useState } from "react";
import Dashboard from "../Dashboard";
import DefaultManagement from "../DefaultManagement";
import Joyride, { ACTIONS, EVENTS } from "react-joyride";
import { useNavigate } from "react-router-dom";
import { Button, Modal, Navbar } from "react-bootstrap";
import SubmitALoan from "../SubmitALoan";
import RequestPayoffDemand from "../RequestPayoffDemand";
import ReportsNDocuments from "../ReportsNDocuments";
import RunAReport from "./run-a-report";
import SSLNavbar from "../../components/Navbar";
import { useDispatch, useSelector } from "react-redux";
import ErrorBoundary from "../../components/ErrorBoundary";
import SupportManagement from "../Ticket";
import AccountComp from "../Account";
import Profile from "../Profile/Profile";
import RoleMenu from "../RoleMenu";
import AdminMenu from "../AdminMenu/AdminMenu";
import SALForm from "../SALForm/index2";
import SideBarMenu from "../../components/Documentation/SideBarMenu";
import Documentation from "../Documentation";
import Help from "../Helps";
import { roleType } from "../../Utils/constant";
import LoanDetails from "../Borrowers/Pages/LoanDetailsBorrower/LoanDetailsBorrower";
import BorrowerDashboardTwo from "../Borrowers/BorrowerDashboardTwo";
import LDPBorrower from "../Borrowers/BorrowerDashboard/LDPBorrower";

let steps = [
  {
    target: ".dashboard",
    content: (
      <>
        <h4>Dashboard</h4>
        <p>
          Get a quick overview of your individual loans. You’ll be able to see
          loan info, next due date, and principal balance. By clicking on the
          loan account number, you’ll be able to see additional details of your
          loan.
        </p>
      </>
    ),
    placement: "right-end",
    disableBeacon: true,
    placementBeacon: "top",
  },
  {
    target: ".portfolio-balance-upcoming-payments",
    content: (
      <>
        <h4>Portfolio balance and upcoming payments</h4>
        <p>View your entire portfolio balance and upcoming payments.</p>
      </>
    ),
    placement: "bottom",
  },
  // {
  //     target: '.loan-count-and-defaulters',
  //     content: <>
  //         <h4>No. of Loans and Defaulters</h4>
  //         <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum</p>
  //     </>,
  // },
  {
    target: ".loan-aging",
    content: (
      <>
        <h4>Loan Aging</h4>
        <p>
          The Loan Aging report gives you a glimpse of the overall health of
          your loans. This report is broken into date ranges of 30 days and
          shows the total loans that are currently due as well as those that are
          past due for each 30-day time increments.
        </p>
      </>
    ),
    placement: "right",
    placementBeacon: "top",
  },
  {
    target: ".loan-aging-popup",
    content: (
      <>
        <h4>Loan Aging</h4>
        <p>
          The Loan Aging report gives you a glimpse of the overall health of
          your loans. This report is broken into date ranges of 30 days and
          shows the total loans that are currently due as well as those that are
          past due for each 30-day time increments.
        </p>
      </>
    ),
    placement: "right",
    placementBeacon: "top",
  },
  {
    target: ".portfolio-at-glance",
    content: (
      <>
        <h4>Portfolio At Glance</h4>
        <p>
          Get a quick overview of your individual loans. You’ll be able to see
          loan info, next due date, and principal balance. By clicking on the
          loan account number, you’ll be able to see additional details of your
          loan.{" "}
        </p>
      </>
    ),
    placementBeacon: "top",
  },
  {
    target: ".upcoming-payments",
    content: (
      <>
        <h4>Upcoming Payments</h4>
        <p>
          This module will display upcoming payments expected on your portfolio.
          This is sorted by earliest to latest, but you will be able to change
          the sorting by clicking on the slider icon. By clicking on the loan
          account number, you will be able to see additional information about
          that loan.
        </p>
      </>
    ),
    placementBeacon: "top",
  },
  {
    target: ".past-loan-portfolio",
    content: (
      <>
        <h4>Past Loan Portfolio</h4>
        <p>
          View a list of your past loans. Whether the loans have paid off or
          went to foreclosure, you’ll be able to do view all loans that are no
          longer active.
        </p>
      </>
    ),
    placementBeacon: "top",
  },
  {
    target: ".past-payments",
    content: (
      <>
        <h4>Past Payments</h4>
        <p>
          This module will display the most recent payments that have been
          received on your portfolio. This is sorted by earliest to latest, and
          you will be able to change the sorting by clicking on the slider icon.
        </p>
      </>
    ),
    placementBeacon: "top",
  },
  {
    target: ".loan-charges",
    content: (
      <>
        <h4>Loan Charges</h4>
        <p>
          This module will display the list of Loan Charges on your portfolio.
        </p>
      </>
    ),
    placementBeacon: "top",
  },
  {
    target: ".attachments-table",
    content: (
      <>
        <h4>Attachments</h4>
        <p>
          This module will show you the attachments with different categories
          available on your portfolio. Click on the categories to view the list
          of attachments.
        </p>
      </>
    ),
    placementBeacon: "top",
  },

  // {
  //   target: ".submit-loan",
  //   content: (
  //     <>
  //       <h4>Submit a Loan</h4>
  //       <p>
  //         Click here to access the Submit a Loan module, where you’ll be able to
  //         upload loan documents for boarding purposes, view statuses of your
  //         loans, and a quick glimpse of the number of loans that you have
  //         submitted.
  //       </p>
  //     </>
  //   ),
  //   placement: "right-end",
  //   placementBeacon: "top",
  // },
  // {
  //   target: ".pending-loan-submissions",
  //   content: (
  //     <>
  //       <h4>Pending Loan Submissions</h4>
  //       <p>
  //         View the statuses of all the loans that you have submitted. The Action
  //         column will display any documents or forms that are needed to complete
  //         the submission. By clicking on the loan account number, you’ll be able
  //         to view additional details of the loan.
  //       </p>
  //     </>
  //   ),
  // },
  // {
  //   target: ".loan-boarded",
  //   content: (
  //     <>
  //       <h4>Loan Boarded</h4>
  //       <p>
  //         The Loan Boarded counter shows you the number of loans that you have
  //         submitted for the year, and the number of loans for the current month.
  //       </p>
  //     </>
  //   ),
  //   placementBeacon: "top",
  // },
  // {
  //   target: ".loan-value",
  //   content: (
  //     <>
  //       <h4>Loan Value</h4>
  //       <p>
  //         The Loan Value graph provides you of a month-to-month breakdown of the
  //         amount of loans that you have submitted for each month of the calendar
  //         year. Click on the calendar icon to change the year.
  //       </p>
  //     </>
  //   ),
  //   placementBeacon: "top",
  // },
  // {
  //   target: ".loan-numbers",
  //   content: (
  //     <>
  //       <h4>Number of Loans</h4>
  //       <p>
  //         The Number of Loans graph provides you of a month-to-month breakdown
  //         of the quantity of loans that you have submitted for each month of the
  //         calendar year. Click on the calendar icon to change year.
  //       </p>
  //     </>
  //   ),
  //   placementBeacon: "top",
  // },

  // {
  //   target: ".rpd",
  //   content: (
  //     <>
  //       <h4>Payoff Demand Module</h4>
  //       <p>
  //         A payoff demand is a statement that shows the borrower the amount
  //         needed to satisfy their debt. The Payoff Demand module will give you
  //         access current outstanding balance amounts and a Loan Payoff Estimate
  //         tool and any payoffs that have been requested. Where you will be able
  //         see quote will include the outstanding principal balance, accrued
  //         interest through the good-through date, and any additional fees or
  //         costs incurred.
  //       </p>
  //     </>
  //   ),
  //   placement: "right-end",
  //   placementBeacon: "top",
  // },
  // {
  //   target: ".select-loan",
  //   content: (
  //     <>
  //       <h4>Select Loan</h4>
  //       <p>Click on the drop-down menu to select a loan.</p>
  //     </>
  //   ),
  //   placementBeacon: "top",
  // },
  // {
  //   target: ".loan-payoff-estimate",
  //   content: (
  //     <>
  //       <h4>Loan Payoff Estimate</h4>
  //       <p>
  //         Once you have selected the loan, you will be able to view a Loan
  //         Payoff Estimate which includes principal balance, unpaid interest,
  //         late charges and fees. This estimated payoff amount is not an official
  //         payoff statement. For more information regarding requestion official
  //         payoff statements please visit -
  //         https://superiorloanservicing.com/payoff-request/
  //       </p>
  //     </>
  //   ),
  //   placementBeacon: "top",
  // },

  {
    target: ".rnd",
    content: (
      <>
        <h4>Reports & Documents</h4>
        <p>
          Automating and managing your reports is an important part of ensuring
          you have the latest data so you can make actionable decision. From
          loan documents and monthly statements to standard reports, you will be
          able to access, manage, download, and view the status of each report
          in this section.
        </p>
      </>
    ),
    placement: "right-end",
  },
  {
    target: ".run-report-button",
    content: (
      <>
        <h4>Run Report</h4>
        <p>Click here to run and access report tools</p>
      </>
    ),
    scrollTo: true,
    scrollToAlignment: "center",
    placement: "top",
    spotlightPadding: 60,
    placementBeacon: "top",
  },
  // {
  //   target: ".run-report-screen",
  //   content: (
  //     <>
  //       <h4>Run Report Screen</h4>
  //       <p>Click here to run and access report tools</p>
  //     </>
  //   ),
  //   placementBeacon: "top",
  // },
  {
    target: ".favorite-report",
    content: (
      <>
        <h4>Favorite Reports</h4>
        <p>View all your favorite reports.</p>
      </>
    ),
    placementBeacon: "top",
  },
  {
    target: ".savedReports",
    content: (
      <>
        <h4>Saved Reports</h4>
        <p>View all your saved reports.</p>
      </>
    ),
    placementBeacon: "top",
  },
  {
    target: ".scheduledReports",
    content: (
      <>
        <h4>Scheduled Reports</h4>
        <p>View all reports that are scheduled to be run.</p>
      </>
    ),
    placement: "right-end",
    placementBeacon: "top",
  },
  {
    target: ".delivered-report",
    content: (
      <>
        <h4>Delivered Reports</h4>
        <p>
          View the reports that have been delivered. You will be able to
          download the report by clicking on the type of report in the Delivery
          Method column.
        </p>
      </>
    ),
    placementBeacon: "top",
  },

  {
    target: ".defaults",
    content: (
      <>
        <h4>Default Management Module</h4>
        <p>
          Managing your defaults is an important part of protecting your
          investment. All the tools in viewing your loan currently being managed
          as default will be accessible here.
        </p>
      </>
    ),
    placement: "right-end",
    placementBeacon: "top",
  },
  // {
  //     target: '.portfolio_balance',
  //     content: <>
  //         <h4>Portfolio Balance</h4>
  //         <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
  //     </>,
  // },
  // {
  //     target: '.upcoming_payments',
  //     content: <>
  //         <h4>Upcoming payments</h4>
  //         <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
  //     </>,
  // },
  {
    target: ".days31PastDue",
    content: (
      <>
        <h4>31+ Days Past Due Defaults</h4>
        <p>
          All loans that are currently 31+ days over due will appear in this
          section. Click on the loan account number to view additional details
          of the loan. You can also click on View All to view all the loans that
          are currently past due.
        </p>
      </>
    ),
    placementBeacon: "top",
  },
  {
    target: ".loansInForeclosure",
    content: (
      <>
        <h4>Loans in Foreclosure</h4>
        <p>
          List of loans that are currently being foreclosed on. Click on the
          loan account number to view additional details of the loan.
        </p>
      </>
    ),
    placementBeacon: "top",
  },
  {
    target: ".loansInBankruptcy",
    content: (
      <>
        <h4>Loan in bankruptcy</h4>
        <p>List of all loans that are currently in bankruptcy proceedings.</p>
      </>
    ),
    placementBeacon: "top",
  },
  {
    target: ".loansInWorkout",
    content: (
      <>
        <h4>Loans in Workout</h4>
        <p>
          This section shows loans that are currently being renegotiated with
          the borrower to put their loans back to good standing.
        </p>
      </>
    ),
    placementBeacon: "top",
  },
  {
    target: ".doc",
    content: (
      <>
        <h4>Help Docs</h4>
        <p>
          New to the platform? Our onboarding and getting started guides will
          walk you through the basics, step-by-step, so you can hit the ground
          running.
        </p>
      </>
    ),
    placement: "right-end",
    placementBeacon: "top",
  },
  {
    target: ".docsearch",
    content: (
      <>
        <h4>Doc Section</h4>
        <p>
          Step-by-step instructions to help you understand and utilize every
          part of the app. From basic tasks to advanced configurations, these
          guides are designed to make your journey smoother.
        </p>
      </>
    ),
    placement: "right-end",
    placementBeacon: "top",
  },
  // {
  //   target: ".docsidebar",
  //   content: (
  //     <>
  //       <h4>Doc Section</h4>
  //       <p>
  //         Step-by-step instructions to help you understand and utilize every
  //         part of the app. From basic tasks to advanced configurations, these
  //         guides are designed to make your journey smoother.
  //       </p>
  //     </>
  //   ),
  //   placement: "right-end",
  //   placementBeacon: "top",
  // },
  {
    target: ".support",
    content: (
      <>
        <h4>Support</h4>
        <p>This section helps you creating tickets for your queries.</p>
      </>
    ),
    placement: "right-end",
    placementBeacon: "top",
  },
  {
    target: ".create-ticket",
    content: (
      <>
        <h4>Create ticket</h4>
        <p>
          The ticket creation process is designed to streamline issue reporting
          by capturing key details such as the issue type, priority level,
          description, and relevant attachments. It ensures all necessary
          information is provided to facilitate efficient resolution and
          effective communication between users and the support team.
        </p>
      </>
    ),
    spotlightPadding: 60,
    scrollTo: true,
    scrollToAlignment: "center",
    placementBeacon: "top",
  },
  {
    target: ".tickets-table",
    content: (
      <>
        <h4>Tickets Table</h4>
        <p>
          View the details of your tickets here. Click on the incident Id to
          navigate to the Ticket Info page.
        </p>
      </>
    ),
    placementBeacon: "top",
  },

  {
    target: ".help",
    content: (
      <>
        <h4>Contact Us</h4>
        <p>
          <b>Explore the FAQs:</b> We’ve gathered answers to common questions in
          the FAQ section, so be sure to take a look!
        </p>
      </>
    ),
    placement: "right-end",
    placementBeacon: "top",
  },
  {
    target: ".helpdropDown",
    content: (
      <>
        <h4>Contact Us</h4>
        <p>
          Our team is dedicated to providing you with the support you need. Feel
          free to reach out using any of these methods, and we’ll do our best to
          assist you promptly.
        </p>
      </>
    ),
    placementBeacon: "left",
  },

  {
    target: ".account",
    content: (
      <>
        <h4>Account</h4>
        <p>
          The Account Section empowers users to manage their accounts
          effortlessly.
        </p>
      </>
    ),
    // placement: "right-end",
    placementBeacon: "top",
  },

  {
    target: ".account-button",
    content: (
      <>
        <h4>Add Account</h4>
        <p>
          Click on the Add Account button to navigate to the Add Account form.
        </p>
      </>
    ),
    // placement: "right-end",
    placementBeacon: "top",
  },
  {
    target: ".change-account",
    content: (
      <>
        <h4>Change Account</h4>
        <p>Change your account from here.</p>
      </>
    ),
    placementBeacon: "top",
  },

  {
    target: ".update-role",
    content: (
      <>
        <h4>Update Role</h4>
        <p>
          Select different role from here and click on the submit button to
          change role.
        </p>
      </>
    ),
    placementBeacon: "top",
  },
  {
    target: ".navbar-role",
    content: (
      <>
        <h4>Change Role</h4>
        <p>You can also change you role from here.</p>
      </>
    ),
    placement: "right-end",
    placementBeacon: "top",
  },
  {
    target: ".navbar-account",
    content: (
      <>
        <h4>Change Account</h4>
        <p>You can also change your account from here.</p>
      </>
    ),
    placement: "right-end",
    placementBeacon: "top",
  },
  {
    target: ".profile-section",
    content: (
      <>
        <h4>Manage Account</h4>
        <p>
          Click here to explore the different functionalities like Manage
          Account, Manage Role, Admin Menu, Loan Onboarding etc.
        </p>
      </>
    ),
    placement: "right-end",
    placementBeacon: "top",
  },
  {
    target: ".lender-ach-form",
    content: (
      <>
        <h4>Manage Account</h4>
        <p>
          You can update the Lender ACH Information by filling out this form.
        </p>
      </>
    ),
    placement: "right-end",
    placementBeacon: "top",
  },
  {
    target: ".add-role-button",
    content: (
      <>
        <h4>Add Role</h4>
        <p>
          Click this button to navigate to the Role Creation form in order to
          add a new role.
        </p>
      </>
    ),
    placement: "right-end",
    placementBeacon: "top",
  },
  {
    target: ".available-role-table",
    content: (
      <>
        <h4>Available Roles</h4>
        <p>
          View all your available roles here. You can also update the role
          information by clicking on the Edit button
        </p>
      </>
    ),
    placement: "right-end",
    placementBeacon: "top",
  },
  {
    target: ".admin-menu-button",
    content: (
      <>
        <h4>Admin Menu</h4>
        <p>Click here to add a new user.</p>
      </>
    ),
    placement: "right-end",
    placementBeacon: "top",
  },
  {
    target: ".admin-menu-table",
    content: (
      <>
        <h4>Admin Menu Table</h4>
        <p>
          View all your added users here. You can also update the user
          information by clicking on Edit button.
        </p>
      </>
    ),
    placement: "right-end",
    placementBeacon: "top",
  },
  {
    target: ".loan-onboarding-form",
    content: (
      <>
        <h4>Loan Onboarding Screen</h4>
        <p>
          In order to complete the loan onboarding process, fill out this
          multitab form.
        </p>
      </>
    ),
    placement: "right-end",
    placementBeacon: "top",
  },
  {
    target: ".thanku",
    content: <>{/* <p>Thank You!</p> */}</>,
    placement: "right-end",
  },
];

const stepsForBorrower = (isRoc) => {
  return [
    {
      target: ".account-summary",
      content: (
        <>
          <h4>Account Summary</h4>
          <p>
            This section gives you an overview of your loans — including total
            active loans, paid off loans, total count, and any loans in
            foreclosure.
          </p>
        </>
      ),
      placementBeacon: "top",
      disableBeacon: true,
      placement: "right-end",
    },
    {
      target: ".paymentSummary",
      content: (
        <>
          <h4>Payment Summary</h4>
          <p>
            Here you can see your total unpaid balance, interest paid
            year-to-date, and any late or NSF fees. Keep track of your financial
            activity easily.
          </p>
        </>
      ),
      placementBeacon: "top",
      disableBeacon: true,
      placement: "left",
    },
    {
      target: ".visualRepresentation",
      content: (
        <>
          <h4>Loan Chart</h4>
          <p>
            A visual bar chart representing the principal balance of each of
            your loans. Great for a quick financial snapshot.
          </p>
        </>
      ),
      placementBeacon: "top",
      disableBeacon: true,
      placement: "top",
    },
    {
      target: ".paymentsSection",
      content: (
        <>
          <h4>Payments</h4>
          <p>
            Manage your payments here. You can make same-day or one-time ACH
            payments, view history, manage bank accounts, schedule payments, or
            request a payoff.
          </p>
        </>
      ),
      placementBeacon: "top",
      disableBeacon: true,
      placement: "left",
    },
    {
      target: ".quickAccess",
      content: (
        <>
          <h4>Quick Access</h4>
          <p>
            Download statements, check saved reports, use the interest or payoff
            calculator – all from this handy section.
          </p>
        </>
      ),
      placementBeacon: "top",
      disableBeacon: true,
      placement: "left",
    },
    {
      target: ".bottomInsights",
      content: (
        <>
          <h4>Loan Insights</h4>
          <p>Check if your loans are in default, workout, or bankruptcy.</p>
        </>
      ),
      placementBeacon: "top",
      disableBeacon: true,
      placement: "top",
    },
    {
      target: isRoc ? "" : ".achStatus",
      content: (
        <>
          <h4>ACH Status</h4>
          <p>
            View how many loans are on recurring ACH (auto-payment). You can
            also check how many are not yet enrolled in automatic payments.
          </p>
        </>
      ),
      placementBeacon: "top",
      disableBeacon: true,
      placement: "right",
    },
    {
      target: ".loansMaturing",
      content: (
        <>
          <h4>Loans Maturing</h4>
          <p>
            This shows the number of loans that will mature within the next 30
            days. Stay informed about upcoming loan closures.
          </p>
        </>
      ),
      placementBeacon: "top",
      disableBeacon: true,
      placement: "top",
    },
    {
      target: ".insuranceExpiring",
      content: (
        <>
          <h4>Insurance Expiring</h4>
          <p>
            Check if any of your loans have insurance policies expiring within
            the next 30 days. Use the "Upload Insurance" button to submit
            updated documents.
          </p>
        </>
      ),
      placementBeacon: "top",
      disableBeacon: true,
      placement: "left",
    },
    {
      target: ".createTicket",
      content: (
        <>
          <h4>Support Tickets</h4>
          <p>
            You can track your support requests here. See how many are closed
            and how many are pending. Click "Create Ticket" to raise a new one.
          </p>
        </>
      ),
      placementBeacon: "top",
      disableBeacon: true,
      placement: "top",
    },
    {
      target: ".loanAgingChart",
      content: (
        <>
          <h4>Loan Aging</h4>
          <p>
            This donut chart shows the status of your loans by how overdue they
            are — from current to over 150 days. A quick way to assess risk and
            overdue trends.
          </p>
        </>
      ),
      placementBeacon: "top",
      disableBeacon: true,
      placement: "left",
    },
    {
      target: ".insuranceExpiryChart",
      content: (
        <>
          <h4>Insurance Expiry Chart</h4>
          <p>
            This chart shows how many loans have insurance policies expiring
            soon, categorized by how many days are left until expiry. Use it to
            prioritize uploads and stay compliant.
          </p>
        </>
      ),
      placementBeacon: "top",
      disableBeacon: true,
      placement: "left",
    },

    // {
    //   target: ".loanDetails",
    //   content: (
    //     <>
    //       <h4>Loans Details</h4>
    //       <p>
    //         The Loan Details Section provides a comprehensive overview of your
    //         loan information. View personal as well as loan related information
    //         of a borrower in this section.
    //       </p>
    //     </>
    //   ),
    //   placementBeacon: "top",
    //   disableBeacon: true,
    //   placement: "right-end",
    // },
    // {
    //   target: ".loan-details-borrower-section",
    //   content: (
    //     <>
    //       <div>
    //         <h4>Borrower Details</h4>
    //         <p>
    //           <strong>Borrower Information:</strong> Includes borrower name,
    //           contact details, address, email, and phone numbers for quick
    //           reference.
    //         </p>
    //       </div>
    //     </>
    //   ),
    //   placementBeacon: "top",
    // },

    // {
    //   target: ".loan-details-borrower-loan-section",
    //   content: (
    //     <>
    //       <div className="text-start">
    //         <h4>Loan Details section</h4>
    //         <p>
    //           The Loan Details Section provides a comprehensive overview of your
    //           loan information. Key features of this section include: <br />
    //           <strong>Financial Details:</strong> Offers a detailed breakdown of
    //           the loan, such as:
    //           <ul>
    //             <li>Loan Amount and Unpaid Principal Balance</li>
    //             <li>Loan Maturity Date</li>
    //             <li>Next Due Date</li>
    //             <li>Current Principal and Interest Due</li>
    //             <li>Late Charges, Interest, and Reserve Balances</li>
    //             <li>Total Amount Due and Loan Stop Date</li>
    //           </ul>
    //         </p>
    //       </div>
    //     </>
    //   ),
    //   placementBeacon: "top",
    // },
    {
      target: ".make-payment-button",
      content: (
        <>
          <div>
            <h4>Payment Action</h4>
            <p>
              <strong>Payment Actions:</strong> This button allow users to
              easily make payments or set up auto-payment options.
            </p>
          </div>
        </>
      ),
      spotlightPadding: 60,
      scrollTo: true,
      // scrollToAlignment: "center",
      placementBeacon: "top",
    },

    {
      target: ".payment-activity-table",
      content: (
        <>
          <h4>Loans Details</h4>
          <p>View all the payment activity related details in this table.</p>
        </>
      ),
      placementBeacon: "top",
      placement: "right-end",
    },
    {
      target: ".attachments-table-borrower",
      content: (
        <>
          <h4>Attachments</h4>
          <p>
            This module will show you the attachments with different categories
            available on your portfolio. Click on the categories to view the
            list of attachments.
          </p>
        </>
      ),
      placementBeacon: "top",
    },

    {
      target: ".doc",
      content: (
        <>
          <h4>Help Docs</h4>
          <p>
            New to the platform? Our onboarding and getting started guides will
            walk you through the basics, step-by-step, so you can hit the ground
            running.
          </p>
        </>
      ),
      placement: "right-end",
      placementBeacon: "top",
    },
    {
      target: ".docsearch",
      content: (
        <>
          <h4>Doc Section</h4>
          <p>
            Step-by-step instructions to help you understand and utilize every
            part of the app. From basic tasks to advanced configurations, these
            guides are designed to make your journey smoother.
          </p>
        </>
      ),
      placement: "right-end",
      placementBeacon: "top",
    },
    // {
    //   target: ".docsidebar",
    //   content: (
    //     <>
    //       <h4>Doc Section</h4>
    //       <p>
    //         Step-by-step instructions to help you understand and utilize every
    //         part of the app. From basic tasks to advanced configurations, these
    //         guides are designed to make your journey smoother.
    //       </p>
    //     </>
    //   ),
    //   placement: "right-end",
    //   placementBeacon: "top",
    // },
    {
      target: ".support",
      content: (
        <>
          <h4>Support</h4>
          <p>This section helps you creating tickets for your queries.</p>
        </>
      ),
      placement: "right-end",
      placementBeacon: "top",
    },
    {
      target: ".create-ticket",
      content: (
        <>
          <h4>Create ticket</h4>
          <p>
            The ticket creation process is designed to streamline issue
            reporting by capturing key details such as the issue type, priority
            level, description, and relevant attachments. It ensures all
            necessary information is provided to facilitate efficient resolution
            and effective communication between users and the support team.
          </p>
        </>
      ),
      spotlightPadding: 60,
      scrollTo: true,
      scrollToAlignment: "center",
      placementBeacon: "top",
    },
    {
      target: ".tickets-table",
      content: (
        <>
          <h4>Tickets Table</h4>
          <p>
            View the details of your tickets here. Click on the incident Id to
            navigate to the Ticket Info page.
          </p>
        </>
      ),
      placementBeacon: "top",
    },

    {
      target: ".help",
      content: (
        <>
          <h4>Contact Us</h4>
          <p>
            <b>Explore the FAQs:</b> We’ve gathered answers to common questions
            in the FAQ section, so be sure to take a look!
          </p>
        </>
      ),
      placement: "right-end",
      placementBeacon: "top",
    },
    {
      target: ".helpdropDown",
      content: (
        <>
          <h4>Contact Us</h4>
          <p>
            Our team is dedicated to providing you with the support you need.
            Feel free to reach out using any of these methods, and we’ll do our
            best to assist you promptly.
          </p>
        </>
      ),
      placementBeacon: "left",
    },

    {
      target: ".account",
      content: (
        <>
          <h4>Account</h4>
          <p>
            The Account Section empowers users to manage their accounts
            effortlessly.
          </p>
        </>
      ),
      // placement: "right-end",
      placementBeacon: "top",
    },

    {
      target: ".account-button",
      content: (
        <>
          <h4>Add Account</h4>
          <p>
            Click on the Add Account button to navigate to the Add Account form.
          </p>
        </>
      ),
      // placement: "right-end",
      placementBeacon: "top",
    },
    {
      target: ".change-account",
      content: (
        <>
          <h4>Change Account</h4>
          <p>Change your account from here.</p>
        </>
      ),
      placementBeacon: "top",
    },

    {
      target: ".update-role",
      content: (
        <>
          <h4>Update Role</h4>
          <p>
            Select different role from here and click on the submit button to
            change role.
          </p>
        </>
      ),
      placementBeacon: "top",
    },
    {
      target: ".navbar-role",
      content: (
        <>
          <h4>Change Role</h4>
          <p>You can also change you role from here.</p>
        </>
      ),
      placement: "right-end",
      placementBeacon: "top",
    },
    {
      target: ".navbar-account",
      content: (
        <>
          <h4>Change Account</h4>
          <p>You can also change your account from here.</p>
        </>
      ),
      placement: "right-end",
      placementBeacon: "top",
    },
    {
      target: ".profile-section",
      content: (
        <>
          <h4>Manage Account</h4>
          <p>
            Click here to explore the different functionalities like Manage
            Account, Manage Role, Admin Menu, Loan Onboarding etc.
          </p>
        </>
      ),
      placement: "right-end",
      placementBeacon: "top",
    },

    {
      target: ".thanku",
      content: <>{/* <p>Thank You!</p> */}</>,
      placement: "right-end",
    },
  ];
};

export default function Walkthrough({ logout }) {
  const navigate = useNavigate();
  const [stepNumber, setStepNumber] = useState(0);
  const [stepIndex, setstepIndex] = useState(-1);
  const [runJoyride, setRunJoyride] = useState(false);
  const [showBeginModal, setshowBeginModal] = useState(true);
  const [showThankuModal, setShowThankuModal] = useState(false);
  const sidebarVisibility = useSelector((state) => state.RS_Sidebar.show);
  const sidebarWidth = useSelector((state) => state.RS_Sidebar.sidebarWidth);
  const selectedRole = useSelector(
    (state) => state?.account?.selectedRole?.value
  );
  const masqueradeEmail = useSelector(
    (state) => state.RS_Authentication.masquerade
  );
  const selectedAccount = useSelector((state) => state.account.selectedAccount);

  const isRoc = selectedAccount?.databasename === "ROC";
  const userId = localStorage.getItem("apex_userid");
  let timer;

  const goToNextStep = () => {
    setstepIndex((prevIndex) => {
      if (prevIndex < steps.length - 1) {
        return prevIndex + 1;
      }
      setRunJoyride(false); // Stop the tour if it's the last step
      return prevIndex;
    });
  };

  // Handle timer for auto-progression
  useEffect(() => {
    // Clear the previous timer (if any) to avoid overlapping
    clearTimeout(timer);

    // Set a new timer for 30 seconds
    if (runJoyride) {
      timer = setTimeout(() => {
        goToNextStep();
      }, 30000);
    }

    // Cleanup timer on component unmount or step change
    return () => clearTimeout(timer);
  }, [stepIndex, runJoyride]);

  const handleJoyrideCallback = (data) => {
    const { action, index, type, lifecycle } = data;
    if (type === "tour:end") {
      // 👉 Run your custom function here

      localStorage.setItem("walkthrough-complete", true);
      setCookie();
      navigate("/login");
    }

    if (lifecycle === "tooltip") {
      window.dispatchEvent(new Event("resize")); // Force recalculation
    }
    if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type)) {
      setstepIndex(index + (action === ACTIONS.PREV ? -1 : 1));
    }
    if (data.step.target === ".submit-loan") {
      setStepNumber(1);
      // setTimeout(() => {
      //   navigate('/default-management')
      // }, 2000);
    } else if (data.step.target == ".rpd") {
      setStepNumber(2);
      // setTimeout(() => {
      //   navigate('/default-management')
      // }, 2000);
    } else if (data.step.target == ".rnd") {
      setStepNumber(3);
      // setTimeout(() => {
      //   navigate('/default-management')
      // }, 2000);
    } else if (data.step.target == ".defaults") {
      setStepNumber(4);
      // setTimeout(() => {
      //   navigate('/default-management')
      // }, 2000);
    }
    // else if (data.step.target == ".run-report") {
    //   setStepNumber(5);
    // }
    else if (data.step.target == ".favorite-report") {
      setStepNumber(3);
    } else if (
      data.step.target == ".doc" &&
      (selectedRole !== roleType.broker ||
        selectedRole !== roleType.brokerAdmin)
    ) {
      setStepNumber(5);
    } else if (data.step.target == ".support" && !masqueradeEmail.isIt) {
      setStepNumber(6);
    } else if (
      data.step.target == ".account" &&
      (selectedRole !== roleType.broker ||
        selectedRole !== roleType.brokerAdmin)
    ) {
      setStepNumber(8);
    } else if (
      data.step.target == ".lender-ach-form" &&
      !masqueradeEmail.isIt
    ) {
      setStepNumber(9);
    } else if (
      data.step.target == ".add-role-button" &&
      (selectedRole === roleType.lenderAdmin ||
        selectedRole === roleType.brokerAdmin) &&
      !masqueradeEmail.isIt
    ) {
      setStepNumber(10);
    } else if (
      data.step.target == ".admin-menu-button" &&
      (selectedRole === roleType.lenderAdmin ||
        selectedRole === roleType.brokerAdmin) &&
      !masqueradeEmail.isIt
    ) {
      setStepNumber(11);
    } else if (data.step.target == ".loan-onboarding-form") {
      setStepNumber(12);
    } else if (
      data.step.target == ".help" &&
      (selectedRole !== roleType.broker ||
        selectedRole !== roleType.brokerAdmin)
    ) {
      setStepNumber(7);
    } else if (
      data.step.target == ".loanDetails" &&
      selectedRole === roleType.borrower
    ) {
      setStepNumber(13);
    }
    if (data.step.target == ".thanku") {
      setRunJoyride(false);
      setShowThankuModal(true);
    }
  };
  // useEffect(()=>{
  //     if(!showBeginModal){
  //         setstepIndex(1);//to start the walkthrough as this is a guided walkthrough now!
  //     }
  // },[showBeginModal])

  function setCookie() {
    const cookieKey = `hasSeenTour_${userId}`;
    document.cookie = `${cookieKey}=true; path=/; max-age=3153600000;`;
  }

  //   function setPersistentCookie(name, value, options = {}) {
  //   const {
  //     maxAge = 3153600000, // 100 years
  //     path = '/',
  //     sameSite = 'Lax',
  //     secure = location.protocol === 'https:', // auto secure on HTTPS
  //   } = options;

  //   let cookieStr = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;
  //   cookieStr += `; max-age=${maxAge}`;
  //   cookieStr += `; path=${path}`;
  //   cookieStr += `; SameSite=${sameSite}`;
  //   if (secure) cookieStr += `; Secure`;

  //   document.cookie = cookieStr;
  // }

  return (
    <div
      className="dashboard-wrapper"
      style={{
        marginLeft: sidebarVisibility ? "calc(" + sidebarWidth + ")" : "0px",
        paddingTop: "calc(60px + 0px)", // replaces marginTop
        transition: "all .3s ease-in-out",
        boxSizing: "border-box", // ensure padding doesn't break layout
      }}
    >
      <div
        className="text-start container-fluid my-0 px-0"
        style={{ overflowY: "scroll" }}
      >
        <Joyride
          callback={handleJoyrideCallback}
          steps={
            selectedRole === roleType.borrower ? stepsForBorrower(isRoc) : steps
          }
          stepIndex={stepIndex} //controlled tour
          continuous={true}
          run={runJoyride}
          // disableScrolling={true}
          spotlightPadding={0}
          scrollOffset={100}
          styles={{
            options: {
              //   arrowColor: '#e3ffeb',
              //   backgroundColor: '#e3ffeb',
              //   overlayColor: 'rgba(79, 26, 0, 0.4)',
              primaryColor: "#438FFE",
              //   textColor: '#004a14',
              //   width: 900,
              zIndex: 100000,
            },
          }}
          floaterProps={{
            offset: 8000,
            placement: "right",
          }}
          showSkipButton
        />

        {stepNumber == 0 && selectedRole !== roleType.borrower && <Dashboard />}
        {stepNumber == 0 && selectedRole == roleType.borrower && (
          <BorrowerDashboardTwo />
        )}
        {stepNumber == 1 && <SubmitALoan />}
        {stepNumber == 2 && <RequestPayoffDemand />}
        {stepNumber == 3 && <ReportsNDocuments />}
        {stepNumber == 4 && <DefaultManagement />}
        {/* {stepNumber == 5 && <RunAReport />} */}
        {stepNumber == 5 && <Documentation />}
        {stepNumber == 6 && <SideBarMenu />}
        {stepNumber == 6 && <SupportManagement />}
        {stepNumber == 7 && <Help />}
        {stepNumber == 8 && <AccountComp />}
        {stepNumber == 9 && <Profile />}
        {stepNumber == 10 && <RoleMenu />}
        {stepNumber == 11 && <AdminMenu />}
        {/* {stepNumber == 12 && <SALForm />} */}
        {stepNumber === 13 && <LDPBorrower />}

        <ThankuModal
          initialShow={showThankuModal}
          handleClose={() => {
            setShowThankuModal(false);
            localStorage.setItem("walkthrough-complete", true);
            setCookie();
            setTimeout(() => {
              navigate("/login");
            }, 300);
          }}
        />
        <BeginModal
          initialShow={showBeginModal}
          handleClose={() => {
            setshowBeginModal(false);
            setstepIndex(0); //to start the walkthrough as this is a guided walkthrough now!
            setRunJoyride(true);
          }}
          handleSkipClose={() => {
            localStorage.setItem("walkthrough-complete", true);
            setCookie();
            setTimeout(() => {
              navigate("/login");
            }, 300);
          }}
        />
      </div>
    </div>
  );
}

const BeginModal = ({ initialShow = true, handleClose, handleSkipClose }) => {
  const sidebarVisibility = useSelector((state) => state.RS_Sidebar.show);
  const sidebarWidth = useSelector((state) => state.RS_Sidebar.sidebarWidth);
  return (
    <div
      className="dashboard-wrapper"
      style={{
        marginLeft: sidebarVisibility ? "calc(" + sidebarWidth + ")" : "0px",
        marginTop: "calc(60px + 0px)",
        transition: "all .3s ease-in-out",
      }}
    >
      <ErrorBoundary>
        <SSLNavbar />
      </ErrorBoundary>
      <Modal show={initialShow} onHide={handleClose} centered>
        {/* <Modal.Header closeButton>
         <Modal.Title>{'Thank you!'}</Modal.Title>
       </Modal.Header> */}
        <Modal.Body
          className="d-flex align-items-center justify-content-center"
          style={{ minHeight: "50vh", textAlign: "center" }}
        >
          <div>
            <h2 className="pb-5">
              Let’s walk through
              <br />
              <span className="text-primary"> LoanlinQ Dashboard</span>
            </h2>
            <p className="pb-5">
              Get a quick overview of your individual loans. You’ll be able
              <br /> to see loan info, next due date, and principal balance. By
              <br /> clicking on the loan account number, you’ll be able to see
              <br /> additional details of your loan.
            </p>
            <Button
              onClick={handleClose}
              style={{
                borderColor: "#438FFE",
                backgroundColor: "#438FFE",
                color: "white",
              }}
            >
              Get Started
            </Button>
            <br />
            <Button
              className="mt-4"
              onClick={handleSkipClose}
              style={{
                borderColor: "#438FFE",
                backgroundColor: "transparent",
                color: "#438FFE",
                fontSize: ".8em",
              }}
            >
              Skip
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};
const ThankuModal = ({ initialShow = true, handleClose }) => {
  return (
    <>
      <Modal show={initialShow} onHide={handleClose} centered>
        {/* <Modal.Header closeButton>
          <Modal.Title>{'Thank you!'}</Modal.Title>
        </Modal.Header> */}
        <Modal.Body
          className="d-flex align-items-center justify-content-center"
          style={{ minHeight: "50vh", textAlign: "center" }}
        >
          <div>
            <h2 className="pb-5">
              Thank You for
              <br /> completing the Demo
            </h2>
            <p className="pb-5">
              For more information, Please contact
              <br /> Ryan Jesena <br />
              <a href="/">rjesena@superiorloanservicing.com</a>
            </p>
            {/* <a href="https://superiorloanservicing.com/loanlinq/"> */}
            <Button
              onClick={handleClose}
              style={{
                borderColor: "#438FFE",
                backgroundColor: "#438FFE",
                color: "white",
              }}
            >
              Finish
            </Button>
            {/* </a> */}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};
